import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Styled components
export const TermsWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const TermsText = styled(Typography)({
  color: '#475467',
  letterSpacing: '0.128px',
  fontSize: 'clamp(9px,3vw, 14px)',
  lineHeight: '160%',
  marginLeft: '2px',
  textAlign: 'center',
});

export const SvTermsWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '5px',
});

export const TermsLink = styled('a')({
  textDecoration: 'underline',
  color: '#2D11AD',
  fontWeight: 600,
  '&:hover': {
    textDecoration: 'underline',
  },
  '&:visited': {
    textDecoration: 'underline',
  },
});

export const TermsError = styled(Typography)({
  fontSize: 'clamp(9px,3vw, 14px)',
  color: '#ED2E38',
  marginLeft: '30px',
});
